<template>
  <dl class="automation-fields">
    <div v-for="field in fields" :key="field[0]">
      <dt>
        <span
          v-if="field[2]"
          v-tooltip="{
            content: field[2],
            placement: 'top',
            offset: 8,
            classes: 'tooltip--new'
          }"
          class="automation-help-label"
          tabindex="0"
        >
          {{ field[0] }}
        </span>
        <span v-else>{{ field[0] }}</span>
      </dt>
      <dd>
        <span
          v-if="clampValues"
          class="automation-field-value--clamped"
        >{{ display(field[1]) }}</span>
        <template v-else>{{ display(field[1]) }}</template>
        <button
          v-if="clampValues && isLongValue(field[1])"
          type="button"
          class="automation-field-view-button"
          @click="$emit('view-value', { label: field[0], value: display(field[1]) })"
        >View full</button>
      </dd>
    </div>
  </dl>
</template>
<script>
import { display } from './model'
export default {
  props: {
    fields: Array,
    clampValues: Boolean
  },
  methods: {
    display,
    isLongValue(value) {
      const text = display(value)
      return text.length > 120 || text.includes('\n')
    }
  }
}
</script>
